import { Button, PageHeader } from 'components';
import { Form, Input, Row, Col, Divider } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import usePrestigeLevels from '../usePrestigeLevels';

const CompanyCategoryEdit = ({ isNew }) => {
  const { t } = useTranslation();
  const { form, handleCreateOrUpdate } = usePrestigeLevels(false);
  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleCreate = () => {
    form.submit();
  };

  const title = isNew ? t('CREARE SEGMENTO') : t('MODIFICA PUBBLICAZIONE DOCUMENTO');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
            nego_tov_id: '',
            nego_sov_id: '',
            nego_rov_id: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label={t('Titolo')} name='title'>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label={t('NEGO ID (TOV)')} name='nego_tov_id'>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('NEGO ID (SOV)')} name='nego_sov_id'>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('NEGO ID (ROV)')} name='nego_rov_id'>
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Divider />
        <Row gutter={16}>
          <Col>
            <Button
              onClick={handleCreate}
              width={'150px'}
              big
              icon={<CheckOutlined />}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CompanyCategoryEdit;
